import React, { Component } from 'react'
import withRouter from '../lib/withRouter';
import { connect } from 'react-redux';
import Authentication from '../../session';
import Service from '../services'
import { BasicLazyParams } from '../../utile';
import BranchToSectionMultiDDTillSecReports from '../BaseDropdownComponents/BranchToSectionMultiDDTillSecReports';
import { getBranchesLatest } from '../../store/actions';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import './styles.scss'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { baseUrlAdmin } from '../../store/apiConstants';
import { Toast } from 'primereact/toast';
import moment from 'moment';
import ClassetMultiSelect from '../../classetComponents/classetMultiSelect';
import { Button } from 'primereact/button';

const genderOptions = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" }
]
const statusOptions = [
    { label: "Active", value: "Active" },
    { label: "InActive", value: "InActive" },

]
class StudentInfomationReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            lazyParams: BasicLazyParams,
            filteredUsers: [],
            selectedStudents: [],
            status: null, // Add this
        }
        this.service = new Service()
    }
    setDropdownValues = (dropdownsData) => {
        const branchChanged = this.state.dropdownsData?.branchIds !== dropdownsData.branchIds;
        this.setState({
            dropdownsData,
            branchChanged,
            studentsList: [],
            selectedStudents: [],
        }, () => {
            if (this.state.dropdownsData?.sectionIds?.length > 0) {
                this.filtersUsersData()
            }

        });
    }
    handleStudentChange = (e) => {
        this.setState({
            selectedStudents: e.value
        }, () => {
            this.filtersUsersData(false);
        });
    }
    filtersUsersData = (isSelectedStudent = true) => {
        const { users, dropdownsData, lazyParams, selectedStudents, gender, status } = this.state;

        let filteredUsers = users?.filter((user) => {

            if (selectedStudents?.length > 0 && !selectedStudents.includes(user.user_id)) {
                return false;
            }

            if (gender && user.gender && user.gender.toLowerCase() !== gender.toLowerCase()) {
                return false;
            }
            if (status && user.status && user.status !== status) {
                return false;
            }

            // Update section filter to handle multiple sections
            if (dropdownsData?.sectionIds?.length > 0 && !dropdownsData.sectionIds.includes(user.sectionId)) {
                return false;
            }

            return true;
        });


        const first = lazyParams.first || 0;
        const rows = lazyParams.rows || 10;
        const paginatedUsers = filteredUsers?.slice(first, first + rows);


        let studentsFilter;
        if (isSelectedStudent) {

            studentsFilter = filteredUsers?.filter(user => {
                if (gender && user.gender.toLowerCase() !== gender.toLowerCase()) {
                    return false;
                }
                else if (status && user.status !== status) {
                    return false;
                }
                else {
                    return ({
                        user_id: user?.user_id,
                        studentName: `${user?.firstName} ${user?.lastName}`
                    })
                }
            }).map((user) => ({
                user_id: user?.user_id,
                studentName: `${user?.firstName} ${user?.lastName}`
            }));
        }

        this.setState({
            filteredUsers: paginatedUsers,
            totalRecords: filteredUsers?.length || 0,
            studentsList: studentsFilter || this.state.studentsList,
        });
    }
    fetchUsersData = () => {
        let academicYear = localStorage.getItem("userAcademicYear")
        const url = `${baseUrlAdmin}/studentReports`;
        let payload = {
            academicYear
        }
        this.setState({ isLoading: true })
        this.service.post(url, payload, true).then(res => {
            if (res && res.status && res.res.status) {
                this.setState({
                    isLoading: false,
                    users: res.res.data,
                    totalRecords: res.res.totalRecords
                }, () => this.filtersUsersData());
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            });
            console.log(e);
        })
    }
    exportToExcel = () => {
        const { users, dropdownsData, selectedStudents, gender, status } = this.state;

        // Get complete filtered data without pagination
        let completeFilteredData = users?.filter((user) => {
            if (selectedStudents?.length > 0 && !selectedStudents.includes(user.user_id)) {
                return false;
            }
            if (gender && user.gender && user.gender.toLowerCase() !== gender.toLowerCase()) {
                return false;
            }
            if (status && user.status && user.status !== status) {
                return false;
            }
            if (dropdownsData?.sectionIds?.length > 0 && !dropdownsData.sectionIds.includes(user.sectionId)) {
                return false;
            }
            return true;
        });

        // Format data for export
        const exportData = completeFilteredData.map(user => ({
            'Student Name': `${user.firstName} ${user.lastName}`,
            'Enrollment No.': user.username.slice(3),
            'Branch': user.branchName,
            'Board': user.boardName,
            'Class': user.className,
            'Section': user.sectionName,
            'Gender': user.gender,
            'DOB': moment(user.dateOfBirth).format("DD-MM-YYYY"),
            'Parent/Guardian Name': user.contactPersonName,
            'Contact Information': user.parentContactNo,
            'Admission Date': moment(user.admissionDate).format("DD-MM-YYYY"),
            'Status': user.status
        }));

        // Create worksheet
        import('xlsx').then(XLSX => {
            const worksheet = XLSX.utils.json_to_sheet(exportData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

            // Generate and download file
            XLSX.writeFile(workbook, `Student_Information_Report_${moment().format('DD-MM-YYYY')}.xlsx`);
        });
    }

    onPage = (event) => {
        this.setState((prevState) => {
            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, () => {
            this.filtersUsersData();
        });
    }

    componentDidMount() {
        this.fetchUsersData();

    }

    render() {
        return (
            <>

                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        padding: '0',
                        marginLeft: "100px",
                        marginTop: "55px",
                        overflow: 'auto',

                    }}>
                    <div className="card filters-card mt-1 pt-0">
                        <BranchToSectionMultiDDTillSecReports setValues={this.setDropdownValues} />
                        <div className="grid my-2">
                            <div className='col-3'>
                                <p className='filter-title'>Student Name/Enrollment Number</p>
                                <ClassetMultiSelect
                                    options={this.state.studentsList}
                                    value={this.state.selectedStudents}
                                    optionValue='user_id'
                                    optionLabel='studentName'
                                    onChange={this.handleStudentChange}
                                    placeholder={(
                                        <div>
                                            <span className=''>Select Student</span>
                                        </div>
                                    )}
                                />
                            </div>
                            <div className='col-3'>
                                <p className='filter-title'>Gender</p>
                                <ClassetDropdown
                                    options={genderOptions}
                                    value={this.state.gender}
                                    optionValue='value'
                                    optionLabel='label'
                                    onChange={(e) => this.setState({
                                        gender: e.value
                                    }, () => {
                                        this.filtersUsersData(false);
                                    })}
                                    placeholder={(
                                        <div>
                                            <span className=''>Select Gender</span>
                                        </div>
                                    )}
                                />
                            </div>
                            <div className='col-3'>
                                <p className='filter-title'>Status</p>
                                <ClassetDropdown
                                    options={statusOptions}
                                    value={this.state.status}
                                    optionValue='value'
                                    optionLabel='label'
                                    onChange={(e) => this.setState({
                                        status: e.value
                                    }, () => {
                                        this.filtersUsersData(false);
                                    })}
                                    placeholder={(
                                        <div>
                                            <span className=''>Select Status</span>
                                        </div>
                                    )}
                                />
                            </div>

                            <div className="col-3 mt-5 flex justify-content-end align-items-center gap-5 ms-auto" style={{ maxWidth: 'fit-content' }}>
                                <Button
                                    label="Download Report"
                                    onClick={this.exportToExcel}
                                    style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#F4F5F6", color: "#000" }}
                                />
                                <Button label="View Analysis" className="p-button-primary"
                                    style={{ width: "137px", height: "40px", padding: "10px", borderRadius: "10px", border: '1px solid #E6E8EA', backgroundColor: "#076EFF", color: "#fff", }} />
                            </div>
                        </div>
                    </div>

                    <div className="datatable-report-demo mx-2">
                        <DataTable
                            value={this.state.filteredUsers}
                            responsiveLayout="scroll"
                            dataKey="id"
                            paginator
                            lazy
                            onPage={this.onPage}
                            resizableColumns
                            first={this.state.lazyParams.first}
                            last={this.state.totalRecords}
                            rows={this.state.lazyParams.rows}
                            totalRecords={this.state.totalRecords}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            globalFilter={this.state.globalFilter}
                            rowClassName={() => 'table-row-style'}
                        >
                            <Column
                                field="code"
                                header="Student Name"
                                body={(rowData) => {
                                    const formatName = (name) => {
                                        return name
                                            ? name.toLowerCase().split(' ')
                                                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                .join(' ')
                                            : '';
                                    };
                                    const firstName = formatName(rowData.firstName);
                                    const lastName = formatName(rowData.lastName);
                                    return <p className="m-0">{`${firstName} ${lastName}`}</p>;
                                }}
                            />
                            <Column
                                header="Enrollment No."
                                body={(rowData) => (
                                    <p className="m-0">{`${(rowData.username).slice(3)}`}</p>
                                )}
                            />
                            <Column header="Branch" field='branchName'></Column>
                            <Column header="Board" field='boardName'></Column>
                            <Column header="Class" field='className'></Column>
                            <Column header="Section" field='sectionName'></Column>
                            <Column header="Gender" field='gender'></Column>
                            <Column header="DOB" field='dateOfBirth' body={(rowData) => {
                                return (
                                    <>
                                        <p>{moment(rowData.dateOfBirth).format("DD-MM-YYYY")}</p>
                                    </>
                                )
                            }}></Column>
                            <Column
                                header="Parent/Guardian Name"
                                field='contactPersonName'
                                body={(rowData) => {
                                    // const formatName = (name) => {
                                    //     return name
                                    //         ? name?.toLowerCase().split(' ')
                                    //             .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                    //             .join(' ')
                                    //         : '';
                                    // };
                                    const formatName = (name) => {
                                        if (typeof name !== 'string') {
                                            console.error("Invalid input for formatName:", name);
                                            return '--TypedNumber--';
                                        }
                                        return name
                                            .toLowerCase()
                                            .split(' ')
                                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                            .join(' ');
                                    };
                                    const name = formatName(rowData.contactPersonName);
                                    return <p className="m-0">{name}</p>;
                                }}
                            />
                            <Column header="Contact Information" field='parentContactNo'></Column>
                            <Column header="Admission Date" field='admissionDate' body={(rowData) => {
                                return (
                                    <>
                                        <p>{moment(rowData.admissionDate).format("DD-MM-YYYY")}</p>
                                    </>
                                )
                            }}></Column>
                            <Column
                                header="Status"
                                field='status'
                                body={(rowData) => (
                                    <div className={`status-badge ${rowData.status === 'Active' ? 'active' : 'inactive'}`}>
                                        {rowData.status}
                                    </div>
                                )}
                            />
                        </DataTable>
                    </div>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </>

        )
    }
}

const mapStatesToProps = (state) => ({
    isLoading: state.boardsData.loading,
    isBranchLoading: state.branchDataLatest.isLoading,
    branchLevels: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data.levels,
    branchData:
        (state.branchDataLatest &&
            state.branchDataLatest.data &&
            state.branchDataLatest.data.data?.filter((each) => {
                if (each.level == 1) {
                    return { ...each };
                }
            })) ||
        [],
    _id: state.branchDataLatest && state.branchDataLatest.data && state.branchDataLatest.data._idF
});
export default connect(mapStatesToProps, { getBranchesLatest })(Authentication(withRouter(StudentInfomationReport)));